import script from "./AddTradePassportClientModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddTradePassportClientModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddTradePassportClientModal.vue?vue&type=style&index=0&id=0a7128d0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a7128d0"]])

export default __exports__